/**
 *
 * DialogFormActions
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { StyledDialogFormActions } from './DialogFormActions.styles';

function DialogFormActions({ $border, fixed, ...props }) {
  return (
    <StyledDialogFormActions $border={$border} $fixed={fixed} {...props} />
  );
}

DialogFormActions.propTypes = {
  $border: PropTypes.bool,
  fixed: PropTypes.bool,
};

export default memo(DialogFormActions);
